import { Navigate, useLocation, useNavigate } from "react-router-dom";
import useUserStore from "./utils/Stores/userStore";
import { useCookies } from "react-cookie";
import SupportText from "./components/Global/SupportText";

function AuthRoute({ children }) {
  const isLogged = useUserStore((state: any) => state.isLogged);
  const location = useLocation();
  const [cookie] = useCookies();

  const navigate = useNavigate();

  if (isLogged) {
    if (location.pathname.startsWith("/invite/")) {
      return (
        <>
          {children}
          <SupportText />
        </>
      );
    }
    return (
      <Navigate
        replace
        to={{
          pathname: cookie?.redirectPath
            ? cookie?.redirectPath
            : location.state?.from
              ? location.state.from
              : "/",
        }}
      />
    );
  }
  return (
    <>
      {children}
      <SupportText />
    </>
  );
}

export default AuthRoute;
